import { HeadingLevel } from "@ariakit/react";
import cn from "classnames";
import React from "react";

import type { Footer, Header } from "../../types/content/feedItem";

import styles from "./TeaserCluster.module.scss";
import { TeaserClusterFooter } from "./TeaserClusterFooter/TeaserClusterFooter";
import { TeaserClusterHeader } from "./TeaserClusterHeader/TeaserClusterHeader";

interface TeaserClusterProps {
  children: React.ReactNode[] | React.ReactNode;
  style: "native" | "premium" | "regular";
  header: Header;
  footer: Footer;
  hasCardStyling?: boolean;
  hasFooterBorder?: boolean;
  isSmallCluster?: boolean;
  isArticlePageTeaser?: boolean;
  isBox?: boolean;
  teaserWeightValue?: number | null;
  isLoggedIn?: boolean;
  articleId?: string;
}

function TeaserCluster({
  children,
  header,
  style,
  footer,
  hasCardStyling = true,
  hasFooterBorder = true,
  isSmallCluster = false,
  isArticlePageTeaser = false,
  isBox = false,
  teaserWeightValue,
  isLoggedIn,
  articleId,
}: TeaserClusterProps) {
  return (
    <div
      className={cn([
        styles.clusterContainer,
        styles[style],
        !hasCardStyling && styles.noCardOutline,
        isSmallCluster && styles.smallCluster,
        isArticlePageTeaser && styles.articlePageTeaser,
      ])}
    >
      <HeadingLevel>
        <TeaserClusterHeader
          teaserWeightValue={teaserWeightValue}
          style={style}
          items={header}
          isSmallCluster={isSmallCluster}
          isBox={isBox}
          isLoggedIn={isLoggedIn}
          articleId={articleId}
        />
        <div className={cn([styles.articleCluster, styles[style]])}>
          {children}
        </div>
        <TeaserClusterFooter
          style={style}
          items={footer}
          hasBorder={hasFooterBorder}
        />
      </HeadingLevel>
    </div>
  );
}

export { TeaserCluster };
export type { TeaserClusterProps };
